function isNullOrUndefined(x: any): x is null | undefined {
  return x === null || typeof x === 'undefined';
}

export default isNullOrUndefined;
